import { useEffect, useState, useRef } from "react";
import pawn from "../assets/images/WPawn.png";
import bishop from "../assets/images/BBishop.png";
import knight from "../assets/images/WQueen.png";
import CourseLevel from "../components/CourseLevel";
import { API_CONFIG } from "../config/api";
import "../styles/coursePage.css";
import { generateAuthToken,generateURN } from "../components/hmac";

const iconMap = {
  beginner: pawn,
  intermediate: bishop,
  advanced: knight
};

const levels = [
  { key: "Beginner", cssKey: "beginner" },
  { key: "Intermediate", cssKey: "intermediate" },
  { key: "Advanced", cssKey: "advanced" }
];

const CoursePage = () => {
  const [openLevel, setOpenLevel] = useState(null);
  const [courseData, setCourseData] = useState([]);
  const [loading, setLoading] = useState(false);

  /* 🔽 refs for auto scroll */
  const levelRefs = {
    Beginner: useRef(null),
    Intermediate: useRef(null),
    Advanced: useRef(null),
  };

  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = async () => {
    try {
      setLoading(true);

      const cachedData = sessionStorage.getItem("COURSE_DATA");
      if (cachedData) {
        setCourseData(JSON.parse(cachedData));
        return;
      }

      const { host,fetchCourse,basic} = API_CONFIG;
      const urn=generateURN();
      const authToken=generateAuthToken(urn);
      const res = await fetch(
        `https://${host}${fetchCourse.path}`,
        {
          method: fetchCourse.method,
          headers: {
            "Content-Type": "application/json",
            Authorization:`Basic ${basic.BASIC_AUTH_CWUSER}`,
            urn:urn,
            authToken:authToken,
          },
          credentials: "include",
        }
      );

      const json = await res.json();
      const data = json.apiResponseData.responseData;

      setCourseData(data);
      sessionStorage.setItem("COURSE_DATA", JSON.stringify(data));
    } catch (err) {
      console.error("API ERROR", err);
    } finally {
      setLoading(false);
    }
  };

  const getModulesByLevel = (levelName) => {
    const levelObj = courseData.find(
      item => item.level.toLowerCase() === levelName.toLowerCase()
    );
    return levelObj ? levelObj.modules : [];
  };

  return (
    <section className="course-page">
      <div className="course-banner">Courses</div>

      {levels.map(level => (
        <div
          key={level.key}
          ref={levelRefs[level.key]}
        >
          <CourseLevel
            level={{ title: level.key, key: level.cssKey }}
            icon={iconMap[level.cssKey]}
            isOpen={openLevel === level.key}
            onClick={() => {
              const isOpening = openLevel !== level.key;
              setOpenLevel(isOpening ? level.key : null);

              if (isOpening) {
                setTimeout(() => {
                  levelRefs[level.key].current?.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                  });
                }, 100);
              }
            }}
            modules={getModulesByLevel(level.key)}
            loading={loading}
          />
        </div>
      ))}
    </section>
  );
};

export default CoursePage;
